import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Environment } from '../../../models/environment.model';
import { Observable } from 'rxjs';
import { VerificationSession } from '../models/verification-session.model';


@Injectable({
  providedIn: 'root'
})
export class VerificationSessionsService {

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: Environment,
  ) { }

  getVerificationSessions(userId: number) {
    return this.httpClient.get<VerificationSession[]>(`${this.environment.api.url}/admin/users/${userId}/verification-sessions`);
  }

  getVerificationSession(sessionId: string) {
    return this.httpClient.get<VerificationSession>(`${this.environment.api.url}/admin/verification-sessions/${sessionId}`);
  }

  /**
   * The reference image is the KYC selfie, so the API requires an admin token on
   * it. That rules out pointing a new tab or an <img src> at the URL — neither
   * sends the Authorization header — so it is fetched through HttpClient (where
   * the token interceptor applies) and handed back as a Blob for the caller to
   * turn into an object URL.
   */
  getVerificationSessionRefImage(sessionId: string): Observable<Blob> {
    return this.httpClient.get(
      `${this.environment.api.url}/admin/verification-sessions/${sessionId}/ref-image`,
      { responseType: 'blob' },
    );
  }
}
